import { entries } from '@direct-frontend/stdlib';
import type { GetValueByPathResponses, SettingsLeafPaths } from '../types';
import { api } from './api';

export async function updateSettingsValues<
    Settings extends { [K in keyof Settings]: K extends SettingsLeafPaths ? GetValueByPathResponses[K] : never },
>(settings: Settings): Promise<void> {
    const settingsForUpdate = entries(settings).map(([path, value]) => {
        return { path: path as SettingsLeafPaths, value };
    });

    if (!settingsForUpdate.length) {
        return Promise.resolve();
    }

    return await api.endpoints.patchValues.mutate(settingsForUpdate);
}

export type UpdateSettingsValuesParams = {
    [K in SettingsLeafPaths]?: GetValueByPathResponses[K];
};
